export default {
	'.*SERVICE_AND_PARTS_FINANCING.*': 'Service',
	'.*SERVICE_SPECIALS.*': 'Service Specials',
	'.*SERVICE_COUPONS.*': 'Service Specials',
	'.*PARTS_SPECIALS.*': 'Parts',
	'.*TOYOTA_SERVICE_CENTER.*': 'Service',
	'.*EXPRESS_MAINTENANCE.*': 'Service',
	'.*BRAKE_SERVICE_REPAIR.*': 'Service',
	'.*TAKATA_AIRBAG_RECALL.*': 'Service',
	'.*TOYOTA_OIL_CHANGE.*': 'Service',
	'.*TOYOTA_OIL_FILTER.*': 'Service',
	'.*BATTERY_SERVICE_REPLACEMENT.*': 'Service',
	'.*COLLISION_CENTER.*': 'Service',
	'.*CABIN_AIR_FILTER.*': 'Service',
	'.*ENGINE_AIR_FILTER.*': 'Service',
	'.*SERVICE_FLUID_REPLACEMENT.*': 'Service',
	'.*YAKIMA_ACCESSORIES.*': 'Accessories',
	'.*GENUINE_ACCESSORIES.*': 'Accessories',
	'.*ACCESSORIES_CATALOGUE.*': 'Accessories',
	'.*FIND_TOYOTA_GENUINE_PARTS.*': 'Parts',
	'.*ORDER_PARTS.*': 'Parts',
	'.*TOYOTA_WIPER_BLADES.*': 'Service',
	'.*TOYOTA_TIRES.*': 'Tire Store',
	'.*TIRE_CENTER.*': 'Tire Store',
	'.*TOYOTA_SCHEDULE_SERVICE.*': 'Schedule Service',
	'.*TOYOTA_SAFETY_RECALLS.*': 'Service',
	'.*DARE_TO_COMPARE.*': 'Service',
	'.*SERVICE_LEAD.*': 'Schedule Service',
	'.*INVENTORY_FEATURED_NEW.*': 'Dealer Specials',
	'.*TOYOTACARE_PLUS.*': 'Service',
	'.*TOYOTACARE.*': 'Service',
	'.*RENT_A_CAR.*': 'Other'
};
